<template>
    <b-modal :id="id" :title="$t('modalTitle')" :centered="true" hide-footer hide-header>
        <h4 class="dark-blue pb-2">{{ $t('modalTitle') }}</h4>
        <SelectKeyResult
            @updateValue="onUpdateValue"
            ref="selectKeyResult"
            :no-elements-found="$t('keyResultNotFound')"
        />
        <div class="d-flex justify-content-end mt-3">
            <b-button
                variant="primary"
                @click="linkKeyResultToInitiative"
                :disabled="keyResultSelected || linkingInitiative"
            >
                <i class="fa fa-spinner fa-pulse" v-if="linkingInitiative"></i>
                {{ $t('linkButton') }}
            </b-button>
            <b-button variant="outline-primary ml-3" @click="closeModal()" :disabled="linkingInitiative">
                {{ $t('cancelButton') }}
            </b-button>
        </div>
    </b-modal>
</template>

<script>
import { linkKeyResultToInitiative } from '../api'
import { success, danger } from '@/lib/notification'
import SelectKeyResult from './components/SelectKeyResult'

export default {
    data() {
        return {
            id: 'link-key-result-modal',
            initiative: {},
            value: {},
            loading: false,
            linkingInitiative: false,
        }
    },
    components: {
        SelectKeyResult,
    },
    created() {
        this.$emit('openModal', this.openModal)
    },
    methods: {
        linkKeyResultToInitiative() {
            this.linkingInitiative = true
            linkKeyResultToInitiative(this.value.value, this.initiative)
                .then(() => {
                    this.closeModal()
                    this.$emit('keyResultLinked')
                    success(this.$t('keyResultLinkedSuccessfully'))
                    this.linkingInitiative = false
                })
                .catch(() => {
                    danger()
                    this.linkingInitiative = false
                })
        },
        openModal(initiative) {
            this.initiative = initiative
            this.$bvModal.show(this.id)
            this.$refs.selectKeyResult.getActiveKRs()
        },
        closeModal() {
            this.$refs.selectKeyResult.reset()
            this.$bvModal.hide(this.id)
        },
        onUpdateValue(value) {
            this.value = value
        },
    },
    computed: {
        keyResultSelected() {
            return !Object.keys(this.value).length > 0
        },
    },
    i18n: {
        messages: {
            'en-US': {
                modalTitle: 'Link to a key result',
                label: 'Select a key result',
                linkButton: 'Link',
                cancelButton: 'Cancel',
                keyResultNotFound: 'Key result not found',
                keyResultLinkedSuccessfully: 'Key result linked successfully',
            },
            'es-ES': {
                modalTitle: 'Vincular a un resultado clave',
                label: 'Seleccione un resultado clave',
                linkButton: 'Vincular',
                cancelButton: 'Cancelar',
                keyResultNotFound: 'Resultado clave no encontrado',
                keyResultLinkedSuccessfully: 'Resultado clave vinculado correctamente',
            },
            'pt-BR': {
                modalTitle: 'Vincular a um resultado chave',
                label: 'Selecione um resultado chave',
                linkButton: 'Vincular',
                cancelButton: 'Cancelar',
                keyResultNotFound: 'Resultado chave não encontrado',
                keyResultLinkedSuccessfully: 'Resultado chave vinculado com sucesso',
            },
        },
    },
}
</script>

<style scoped>
.dark-blue {
    color: #022b4f;
}
</style>
